import { Grid } from "@mui/material";
import Switch from "@mui/material/Switch";
import React, { useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Editor from "../../../Editor/Editor";
import { updateOptionsForUser } from "../../../Url";
import { isDeveloper } from "../../Tools/Tools";
import { useAtom } from "jotai";
import {
  animationsAtom,
  currentTheme,
  gridSelectedRecordColorAtom,
  hideToastNotificationsAtom,
} from "../../../../atoms";
import { toast } from "react-toastify";
import { APP_THEME_OPTIONS, DEFAULT_APP_THEME, normalizeAppThemeName } from "../../../../theme/appTheme";

// список для редактора
function getListForThemeEditor() {
  return APP_THEME_OPTIONS.map((themeOption, index) => ({ label: themeOption.label, id: index }));
}

const themeByLabel = APP_THEME_OPTIONS.reduce((acc, themeOption) => {
  acc[themeOption.label] = themeOption.value;
  return acc;
}, {});

const labelByTheme = APP_THEME_OPTIONS.reduce((acc, themeOption) => {
  acc[themeOption.value] = themeOption.label;
  return acc;
}, {});

export default function ThemeChange(props) {
  const canChangeTheme = import.meta.env.DEV || isDeveloper();
  const [animation, setAnimations] = useAtom(animationsAtom);
  const [hideToastNotifications, setHideToastNotifications] = useAtom(hideToastNotificationsAtom);
  const [gridSelectedRecordColor, setGridSelectedRecordColorAtom] = useAtom(gridSelectedRecordColorAtom);
  const [theme, setTheme] = useAtom(currentTheme);
  // текст для темы
  const [themeVal, setThemeVal] = useState(labelByTheme[theme] || labelByTheme[DEFAULT_APP_THEME]);

  function onEditTheme(data) {
    if (!canChangeTheme) return;

    setThemeVal(data.value);

    // обновление внутренних данных редактора
    data.setValue({ label: data.value, id: data.tag });
    // если инпут не контролируемый то нужно обновлять значение тут:
    // data.setInputValue(data.value);
    const selectedTheme = normalizeAppThemeName(themeByLabel[data.value]);
    setTheme(selectedTheme);
    updateOptionsForUser({ theme: selectedTheme });
  }
  return (
    <Grid container direction={"column"} justifyContent={"center"} alignItems={"flex-start"} sx={{ m: 0, pl: 2 }}>
      <Grid item>
        <FormControlLabel
          control={
            <Switch
              disabled={!isDeveloper()}
              checked={animation}
              onChange={(event) => {
                setAnimations(event.target.checked);
                updateOptionsForUser({ animations: event.target.checked });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          sx={{ display: "none" }}
          label="Анимации"
          labelPlacement="end"
        />
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Switch
              checked={hideToastNotifications}
              onChange={(event) => {
                setHideToastNotifications(event.target.checked);
                updateOptionsForUser({ hideToastNotifications: event.target.checked });
                if (event.target.checked) toast.dismiss();
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          label="Скрыть всплывающие уведомления"
          labelPlacement="end"
        />
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Switch
              checked={gridSelectedRecordColor}
              onChange={(event) => {
                setGridSelectedRecordColorAtom(event.target.checked);
                updateOptionsForUser({ gridSelectedRecordColor: event.target.checked });
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          label="Выделять запись цветом в таблице"
          labelPlacement="end"
        />
      </Grid>
      <Grid
        style={{
          height: "27px",
          width: "250px",
          display: "flex",
          alignItems: "center",
          pointerEvents: canChangeTheme ? "auto" : "none",
          opacity: canChangeTheme ? 1 : 0.5,
        }}
        item
      >
        <div style={{ width: "50px" }}>Тема:</div>
        <div
          style={{
            height: "27px",
            border: "1px solid #eeeeee",
          }}
        >
          <Editor
            // контролируемый input с помощью состояния
            value={themeVal}
            // функиця редактирования
            onEdit={onEditTheme}
            // стиль выпадающего списка = 1
            editStyle={65}
            // первый вариант списка
            onDropDownList={getListForThemeEditor}
            // альтернативный вариант списка
            // list={"Текущая тема\r\nТема 2"}
          />
        </div>
      </Grid>
    </Grid>
  );
}
